import React , { useEffect, useRef } from 'react';
import "./Funcionalidades.css";
import { Link } from 'react-router-dom'; // Importar Link
import { BuscadorHome } from '../../components/home/BuscadorHome';
import HeaderHome from '../../components/headerHome/HeaderHome'
import { MiFooter } from "../../components/footer/MiFooter";
import banner2Image from './img/banner2.jpeg';
import banner3Image from "./img/Cognitiva.jpeg";
import banner4Image from './img/Vita.jpeg';
import imgPrincipal from "./img/principal2.jpg";
import ACP from "./img/ACP.png";
import factura from "./img/factura.png";

export const Funcionalidades = (props = {}) => {

        const noop = () => {};

    const {
        Empresas = [],
        setEmpresas = noop,
        mapa = null,
        setMapa = noop,
        setModalUbiacion = noop,
        setEmpresasCargadas = noop,
        getEmpresas_preRegistradas = noop,
        limite = 0,
        setBuscarNombre = noop,
        setBuscarCategoria = noop,
        setBuscarLocalidad = noop,
        setBuscarProvincia = noop,
    } = props;
const bannerRefs = useRef([]);

const addToRefs = (el) => {
    if (el && !bannerRefs.current.includes(el)) {
        bannerRefs.current.push(el);
    }
};

useEffect(() => {
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("visible");
                }
            });
        },
        { threshold: 0.2 }
    );

    bannerRefs.current.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
}, []);

    return (
        <>
        <HeaderHome />
        <div className="funcionalidades">

        <section className="funcionalidades-hero">

            <div className="hero-image">
                <img src={imgPrincipal} alt="Equipo Cuidatia" />
            </div>

            <div className="hero-card">

                <h1>Funciones de Cuidatia</h1>

                <p>
                    Una plataforma que <b>acompaña</b> todo el ciclo del cuidado,
                    desde el <b>conocimiento profundo</b> de la persona hasta la
                    coordinación de profesionales y la <b>mejora continua</b> de 
                     su calidad de vida.
                </p>

            </div>

        </section>

            {/* 7.1 Historia de vida */}
            <div ref={addToRefs} className="cuidatia-banner reverse slide-right">
                <div className="cuidatia-image-container">
                    <a href="https://cuidatiavita.cuidatia.org/" target="_blank" rel="noopener noreferrer">
                        <img src={ACP} alt="Cuidatia Telemonitorización" className="cuidatia-image" />
                    </a>
                </div>
                <div className="cuidatia-text-container">
                    <h2>Historia de Vida y ACP</h2>
                    <p>
                        La Historia de Vida reúne toda la información que hace única a cada persona: 
                        su biografía, gustos, rutinas, relaciones, necesidades, objetivos y actividades 
                        cotidianas. Incorpora entrevistas por voz con transcripción automática, 
                        participación familiar, generación de pictogramas y un Plan de Atención y Vida 
                        en primera persona que evoluciona de forma continua para acompañar cada etapa.
                    </p>
                    <strong>Conocer a la persona es el primer paso para cuidarla.</strong>
                    <br />
                    <a 
                        href="https://cuidatiavita.cuidatia.org/" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="cuidatia-btn"
                    >
                        Acceso a Vita
                    </a>
                </div>
            </div>

            {/* 7.2 Facturazión electrónica */}
            <div ref={addToRefs} className="cuidatia-banner slide-left">
                <div className="cuidatia-image-container">
                    <img src={factura} alt="Cuidatia Cognitiva" className="cuidatia-image" />
                </div>
                <div className="cuidatia-text-container">
                    <h2>Facturación electrónica</h2>
                    <p>
                        Gestiona toda la administración económica desde un único lugar. 
                        Genera facturas individuales o periódicas, registra los servicios prestados, 
                        controla cuotas y copagos, integra proveedores y realiza el seguimiento de 
                        cobros e incidencias. Todo ello con historial económico, facturación electrónica 
                        y exportación contable para una gestión ágil, segura y adaptada a las organizaciones.
                    </p>
                    <strong>Gestión económica integrada con la prestación de servicios.</strong>
                </div>
            </div>

            {/* 7.3 Domotización de hogares */}
            <div ref={addToRefs} className="cuidatia-banner reverse slide-right">
                <div className="cuidatia-image-container">
                    <img src={banner4Image} alt="Cuidatia Telemonitorización" className="cuidatia-image" />
                </div>
                <div className="cuidatia-text-container">
                    <h2>Domotización de hogares inteligentes</h2>
                    <p>
                        Ayuda profesional cuando de 
                        verdad la necesitas. Cuidados 
                        verificados y de confianza, a 
                        domicilio o en consulta, con 
                        reserva inmediata, horarios 
                        flexibles y seguimiento claro. Para 
                        que cada necesidad tenga una 
                        respuesta rápida, segura y 
                        profundamente humana.
                    </p>
                    <strong>Seguimiento continuo, tranquilidad real.</strong>
                </div>
            </div>

            {/* 7.4 Cuidatia Cognitiva */}
            <div ref={addToRefs} className="cuidatia-banner slide-left">
                <div className="cuidatia-image-container">
                    <a href="https://cuidatiacognitiva.adiper.es/" target="_blank" rel="noopener noreferrer">
                        <img src={banner3Image} alt="Cuidatia Cognitiva" className="cuidatia-image" />
                    </a>
                </div>
                <div className="cuidatia-text-container">
                    <h2>Programas digitales de mejora física y cognitiva</h2>
                    <p>
                        Activa la mente y sostiene el ánimo. Juegos y rutinas accesibles que entrenan memoria,
                        atención y lenguaje, con niveles graduales, progreso visible y propuestas diarias que crean
                        hábito sin presión. Una experiencia cuidada para mantener la mente en marcha y la autoestima alta.
                    </p>
                    <strong>Pequeños retos, grandes beneficios.</strong>
                    <br />
                    <a
                        href="https://cuidatiacognitiva.adiper.es/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cuidatia-btn"
                    >
                        Acceso a Cognitiva
                    </a>
                </div>
            </div>

            {/* Banner 2: Imagen Derecha, Texto Izquierda */}
            <div ref={addToRefs} className="cuidatia-banner reverse slide-right">
                <div className="cuidatia-image-container">
                    <Link to="/cuidados">
                        <img src={banner2Image} alt="Cuidatia Cognitiva" className="cuidatia-image" />
                    </Link>
                </div>
                <div className="cuidatia-text-container">
                    <h2>Marketplace de servicios</h2>
                    <p>
                        Ayuda profesional cuando de verdad la necesitas. Cuidados verificados y de confianza,
                        a domicilio o en consulta, con reserva inmediata, horarios flexibles y seguimiento claro.
                        Para que cada necesidad tenga una respuesta rápida, segura y profundamente humana.
                    </p>
                    <strong>Cuidados que llegan cuando los necesitas.</strong>
                    <br />
                    <div className="cuidatia-search-card">
                        <BuscadorHome
                            Empresas={Empresas}
                            setEmpresas={setEmpresas}
                            mapa={mapa}
                            setMapa={setMapa}
                            setModalUbiacion={setModalUbiacion}
                            setEmpresasCargadas={setEmpresasCargadas}
                            getEmpresas_preRegistradas={getEmpresas_preRegistradas}
                            limite={limite}
                            setBuscarNombre={setBuscarNombre}
                            setBuscarCategoria={setBuscarCategoria}
                            setBuscarLocalidad={setBuscarLocalidad}
                            setBuscarProvincia={setBuscarProvincia}
                        />
                    </div>
                </div>
            </div>
        </div>
                    <MiFooter />
        </>
    );
};